import React from "react";

function SearchIcon({ fill = "#424242" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9422 17.0577L14.0305 13.1468C15.1642 11.7856 15.7296 10.0398 15.6089 8.27238C15.4883 6.505 14.6909 4.85217 13.3826 3.65772C12.0744 2.46328 10.356 1.8192 8.58492 1.85944C6.81388 1.89969 5.12653 2.62118 3.87389 3.87383C2.62125 5.12647 1.89976 6.81382 1.85951 8.58486C1.81926 10.3559 2.46334 12.0743 3.65779 13.3825C4.85223 14.6908 6.50506 15.4882 8.27244 15.6089C10.0398 15.7295 11.7857 15.1642 13.1469 14.0304L17.0578 17.9421C17.1159 18.0002 17.1848 18.0463 17.2607 18.0777C17.3366 18.1091 17.4179 18.1253 17.5 18.1253C17.5821 18.1253 17.6634 18.1091 17.7393 18.0777C17.8152 18.0463 17.8841 18.0002 17.9422 17.9421C18.0003 17.8841 18.0463 17.8151 18.0777 17.7392C18.1092 17.6634 18.1253 17.5821 18.1253 17.4999C18.1253 17.4178 18.1092 17.3365 18.0777 17.2606C18.0463 17.1848 18.0003 17.1158 17.9422 17.0577ZM3.125 8.74993C3.125 7.63741 3.4549 6.54988 4.07298 5.62485C4.69106 4.69983 5.56957 3.97885 6.5974 3.55311C7.62524 3.12737 8.75624 3.01598 9.84738 3.23302C10.9385 3.45006 11.9408 3.98579 12.7275 4.77246C13.5141 5.55913 14.0499 6.56141 14.2669 7.65255C14.484 8.74369 14.3726 9.87469 13.9468 10.9025C13.5211 11.9304 12.8001 12.8089 11.8751 13.427C10.9501 14.045 9.86252 14.3749 8.75 14.3749C7.25866 14.3733 5.82888 13.7801 4.77435 12.7256C3.71981 11.6711 3.12665 10.2413 3.125 8.74993Z"
        fill={fill}
      />
    </svg>
  );
}

export default SearchIcon;
